import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { evPersonalizationMarkerHover, evPersonalizationMarkerSigninClick } from 'events/landing';
import {
  NON_RECOGNIZED_USER,
  RECOGNIZED_USER_INSUFFICIENT_DATA,
  RECOGNIZED_USER_SUFFICIENT_DATA
} from 'constants/personalizationMarkerTypes';

import PersonalizationMarkerNonRecIconLarge from 'images/not-recognized-marker.svg';
import PersonalizationMarkerRecIconLarge from 'images/recognized-marker.svg';
import css from 'styles/components/landing/personalizationMarker.scss';
import Tooltip from 'components/common/Tooltip';
import { track } from 'apis/amethyst';

const PersonalizationMarker = props => {
  const onMouseEnter = () => {
    const { componentName, type } = props;
    track(evPersonalizationMarkerHover, {
      componentName,
      type
    });
  };

  const onSignInClick = () => {
    const { componentName, type } = props;
    track(evPersonalizationMarkerSigninClick, {
      componentName,
      type
    });
  };

  const getTypeInfo = type => {
    switch (type) {
      case NON_RECOGNIZED_USER:
        return {
          className: css.pNonRecMrkSmall,
          label: 'Non-recognized customer',
          contents: <>
            <div data-test-img-type={type}>
              <img src={PersonalizationMarkerNonRecIconLarge} alt="" />
            </div>
            <div>
              <p>These items can be tailored for you.</p>
              <p><Link to="/login" onClick={onSignInClick}>Sign In</Link> to see items which match your preferences.</p>
            </div>
          </>
        };
      case RECOGNIZED_USER_INSUFFICIENT_DATA:
        return {
          className: css.pRecMrkSmall,
          label: 'Recognized customer',
          contents: <>
          <div data-test-img-type={type}>
            <img src={PersonalizationMarkerRecIconLarge} alt="" />
          </div>
          <div>
            <p>We do not have enough information about your preferences to personalize these items. Please browse around more to help us learn what you like.</p>
          </div>
          </>
        };
      case RECOGNIZED_USER_SUFFICIENT_DATA:
        return {
          className: css.pRecMrkSmall,
          label: 'Recognized customer',
          contents: <>
          <div data-test-img-type={type}>
            <img src={PersonalizationMarkerRecIconLarge} alt="" />
          </div>
          <div>
            <p>These items have been personalized based on your preferences. If these don't match your tastes, please browse around more to help us learn what you like.</p>
          </div>
          </>
        };
    }

    return {
      className: null,
      label: 'Unknown personalization icon',
      contents: ''
    };
  };

  const { iconAlignment, contentsAlignment, type, showOnMobile, shrinkTooltipOnTabletPortrait, contents } = props;
  const pointyDirection = contentsAlignment ? contentsAlignment : iconAlignment === 'right' ? 'left' : 'right';
  const alignToLeftSideOfIcon = (iconAlignment === 'left' && contentsAlignment === 'left');
  const { className: markerClassName, label: markerLabel, contents: defaultContents } = getTypeInfo(type);
  return <Tooltip
    tooltipId="personalizationMarker"
    wrapperClassName={cn(css.tooltipWrapper, { [css.pMrkSmallRightAlgn]: (iconAlignment === 'right') })}
    contentClassName={cn(css.tooltipContent, { [css.shrinkOnTabletPortrait]: !!shrinkTooltipOnTabletPortrait })}
    tooltipClassName={cn(css.tooltip, { [css.leftSideOfIcon]: alignToLeftSideOfIcon })}
    direction={pointyDirection}
    onMouseEnter={onMouseEnter}
    showOnMobile={showOnMobile}
    content={contents || defaultContents}>
    <span className={cn(css.pMrkSmall, markerClassName)} aria-label={markerLabel} />
  </Tooltip>;
};

PersonalizationMarker.propTypes = {
  iconAlignment: PropTypes.string,
  contents: PropTypes.string,
  contentsAlignment: PropTypes.string,
  showOnMobile: PropTypes.bool,
  type: PropTypes.number.isRequired // As defined in constants/personalizationMarkerTypes
};

PersonalizationMarker.defaultProps = {
  iconAlignment: 'left',
  contents: '',
  contentsAlignment: '',
  showOnMobile: true
};

export default PersonalizationMarker;
